import Custom from "../../../Components/Buttons/Custom";
import { useState } from "react";
import WithdrawModal from "./WithdrawModal";

export default function Button() {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <div className="w-full flex justify-end p-0.5">
        <Custom
          onClick={() => setShowModal(true)}
          text="درخواست برداشت سود"
          textShadow={true}
          className="bg-zi-buttonbg-primary px-6 py-2 text-zi-text-dark hocus:opacity-85"
        />
      </div>
      {showModal && (
        <div
          className="w-full fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur"
          onClick={() => setShowModal(false)}
        >
          <div
            className="w-11/12 max-w-md flex justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <WithdrawModal
              setIsWithdrawOpen={setShowModal}
              onClose={() => setShowModal(false)}
            />
          </div>
        </div>
      )}
    </>
  );
}
